import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  background-size: cover;
  background-position: center;
  color: #000;
  border-radius: 0; /* sin bordes redondeados */
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
  gap: 40px;
`;

const TextSection = styled.div`
  flex: 1;
  padding: 20px;
  font-size: 1.25rem; /* más grande */
  line-height: 1.75;
  text-align: left; /* alineado a la izquierda */
  max-width: 650px;
`;

const HighlightSection = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Highlight = styled.div`
  background: transparent;
  color: #e63946;
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 10px;
  line-height: 1.2;
`;

const BigNumber = styled.div`
  font-size: 4rem;
  font-weight: 900;
  color: #e63946;
  margin: 5px 0;
`;

const BlockchainCard = () => {
  return (
    <CardContainer>
      <TextSection>
        <p>
          La principal ventaja de la tecnología <strong>blockchain</strong> es su{" "}
          <strong>transparencia</strong> y <strong>seguridad</strong>. Las acciones de todos los participantes son
          abiertas y visibles en tiempo real, lo que evita falsificaciones de información.
        </p>
        <p>
          Como resultado, la demanda de profesionales en blockchain se ha disparado hasta un{" "}
          <strong>700%</strong> en los últimos años.
        </p>
        <p>
          El impacto es altamente positivo: el mercado evoluciona hacia la industria 4.0, con aprendizaje automático
          aplicado a IoT y soluciones de inteligencia artificial potenciadas por blockchain.
        </p>
      </TextSection>
      <HighlightSection>
        <Highlight>Actualmente hay</Highlight>
        <BigNumber>alta demanda</BigNumber>
        <Highlight>y escasez de talento</Highlight>
        <Highlight>en blockchain</Highlight>
      </HighlightSection>
    </CardContainer>
  );
};

export default BlockchainCard;
